// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/radio.ts
export const Radio = {
  baseStyle: (props) => ({
    label: {
      cursor: 'pointer',
    },
  }),

  sizes: {
    md: {
      control: { w: 5, h: 5 },
      label: { fontSize: 'sm' },
    },
  },
}
